import request from './request';

export async function getDocuments(filter) {
  const res = await request.get(`/portal/api/session/approval/documents`, {
    params: { paging: { filter } },
  });
  return res.data;
}

export async function getDocumentDetail(id) {
  const res = await request.get(`/portal/api/session/approval/documents/${id}`);
  return res.data;
}

export async function requestApproval(payload) {
  const res = await request.post(`/portal/api/session/approval/documents`, payload);
  return res;
}

export async function changeStateOfApproval(params) {
  const res = await request.put(`/portal/api/session/approval/documents`, params);
  return res;
}

export async function updateApproval(id, params) {
  const res = await request.put(`/portal/api/session/approval/documents/${id}`, params);
  return res;
}

export async function assignVd(groupId) {
  const res = await request.post(`/portal/api/session/vdgroups/${groupId}/assign-vd`);
  return res;
}
